module.exports = __webpack_public_path__ + "static/media/adv-media-gallery.0e730236.png";